import { mergeTheme, theme as designSystemTheme } from '@modusign/design-system';

import { colorSchemes } from '@app/theme/colorScheme';

import * as colors from './colors';

export const globalNavigationBarWidth = '200px';

const theme = mergeTheme(designSystemTheme, {
  zIndices: {
    // 서비스 기능 absolute 기본
    absolute: 100,
    // 서비스 레이아웃 층
    fixedLayout: 500,
    pdfLayout: 500,
    // 오버레이 - 모달, 스피너
    overlay: 1000,
    virtualLayer: 502,

    // Fields
    marker: 100,
    mouseMarker: 501,
    checkboxFieldEmpty: 107,
    checkboxFieldEntered: 108,
    checkboxFieldFocused: 110,
    checkboxFieldHovered: 109,
    signatureFieldEmpty: 105,
    signatureFieldEntered: 101,
    signatureFieldFocused: 110,
    signatureFieldHoveredEmpty: 106,
    signatureFieldHoveredEntered: 102,
    textFieldEmpty: 105,
    textFieldEntered: 103,
    textFieldFocused: 110,
    textFieldHoveredEmpty: 106,
    textFieldHoveredEntered: 104,
  },
  colors,
  ...colorSchemes,
});

export type AppThemeType = typeof theme;
export default theme;
